import 'core-js/stable'

//fonts
import '@mdi/font/css/materialdesignicons.css'
//bootstrap
import 'bootstrap/dist/css/bootstrap.min.css'

import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import * as Sentry from '@sentry/vue'
// @ts-expect-error vue-tel-input not support ts
import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/vue-tel-input.css'

import App from './App.vue'
import router from './router'

import config from './config'
import translationEn from './translations/translationEn'
import translationAr from './translations/translationAr'

const app = createApp(App)
Sentry.init({
  app,
  dsn: 'https://2ee0f5889d4f4132aefd9cd6daf8fddb@o92284.ingest.us.sentry.io/1306132',
  integrations: [],
  environment: config.environment(),
  release: config.release(),
  attachStacktrace: true
})

import('@sentry/vue').then((lazyLoadedSentry) => {
  Sentry.addIntegration(
    lazyLoadedSentry.httpClientIntegration({
      failedRequestTargets: [
        new RegExp(`^${config.apiBaseUrl().replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')}(\\/.*)?$`)
      ]
    })
  )

  Sentry.addIntegration(lazyLoadedSentry.browserTracingIntegration({ router }))
  Sentry.addIntegration(
    lazyLoadedSentry.captureConsoleIntegration({ levels: ['warn', 'error', 'debug', 'assert'] })
  )
})

const i18n = createI18n({
  legacy: false,
  locale: 'ar',
  fallbackLocale: 'en',
  messages: {
    ar: translationAr,
    en: translationEn
  }
})

app.use(i18n)

//@doc: https://iamstevendao.com/vue-tel-input/usage/props.html
app.use(VueTelInput, {
  dropdownOptions: {
    showDialCodeInSelection: true,
    showSearchBox: true,
    searchBoxPlaceholder: ''
  },
  inputOptions: {
    autofocus: true,
    id: 'phone-number-field',
    showDialCode: false,
    placeholder: '',
    required: true,
    styleClasses: ['form-control']
  },
  mode: 'auto',
  preferredCountries: ['sa', 'eg', 'kw'],
  autoDefaultCountry: false
})

app.use(router)

app.mount('#app')

export default i18n
